import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/true-size-of-continents/page.tsx");
